// Central content + assets for South Icon Awards 2026
export const LOGO_URL = "/south-icon-logo.png";

export const IMAGES = {
  trophy_hero:
    "https://images.unsplash.com/photo-1714548474550-d533620651c7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTN8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBhd2FyZCUyMHRyb3BoeSUyMGdvbGRlbiUyMGxpZ2h0JTIwYmxhY2slMjBiYWNrZ3JvdW5kfGVufDB8fHx8MTc4OTk5NjE3OHww&ixlib=rb-4.1.0&q=85",
  golden_award:
    "https://images.unsplash.com/photo-1680448588632-3eea32ed623e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTN8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBhd2FyZCUyMHRyb3BoeSUyMGdvbGRlbiUyMGxpZ2h0JTIwYmxhY2slMjBiYWNrZ3JvdW5kfGVufDB8fHx8MTc4OTk5NjE3OHww&ixlib=rb-4.1.0&q=85",
  venue_chancery:
    "https://images.unsplash.com/photo-1690812304112-df39679c5797?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzN8MHwxfHNlYXJjaHw0fHxsdXh1cnklMjBob3RlbCUyMGhhbGwlMjBiYW5xdWV0JTIwbGlnaHRpbmd8ZW58MHx8fHwxNzg5OTk2MTg1fDA&ixlib=rb-4.1.0&q=85",
  gala_banquet:
    "https://images.pexels.com/photos/37240724/pexels-photo-37240724.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  stage_presentation:
    "https://images.unsplash.com/photo-1769798644300-e53957efab03?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwzfHxidXNpbmVzcyUyMGxlYWRlcnMlMjBhd2FyZHMlMjBzdGFnZSUyMGNvbmZlcmVuY2V8ZW58MHx8fHwxNzg5OTk2MTg1fDA&ixlib=rb-4.1.0&q=85",
  speakers_stage:
    "https://images.unsplash.com/photo-1762968274962-20c12e6e8ecd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwyfHxidXNpbmVzcyUyMGxlYWRlcnMlMjBhd2FyZHMlMjBzdGFnZSUyMGNvbmZlcmVuY2V8ZW58MHx8fHwxNzg5OTk2MTg1fDA&ixlib=rb-4.1.0&q=85",
};

export const EVENT = {
  presenters: "VV Entertainments & HW Creations",
  title: "South Icon Awards 2026",
  city: "Bangalore",
  tagline:
    "A grand celebration of excellence, leadership, social impact & achievement.",
  date: "10 October 2026",
  time: "6:00 PM Onwards",
  venue: "RG Royal Hotel, Bangalore",
  targetDate: "2026-10-10T18:00:00+05:30",
  contacts: ["+91 84948 46767", "+91 93842 72666", "+91 96774 81111"],
};

export const CATEGORIES = [
  {
    id: "global-women",
    title: "Global Women Icon Awards 2026",
    subtitle: "Celebrating women of vision, courage & achievement.",
    badge: "Women Leaders",
    icon: "Crown",
  },
  {
    id: "south-business",
    title: "South Indian Business Icon Awards 2026",
    subtitle: "Celebrating visionary entrepreneurs & innovators.",
    badge: "Entrepreneurship",
    icon: "Briefcase",
  },
  {
    id: "jfc-social",
    title: "JFC Social Icon Awards 2026",
    subtitle: "Recognising individuals making meaningful contributions to society.",
    badge: "Social Impact",
    icon: "HeartHandshake",
  },
  {
    id: "future-icon",
    title: "Future Icon Awards 2026",
    subtitle: "Honouring exceptional rising leaders & future icons shaping tomorrow.",
    badge: "Rising Leaders",
    icon: "Rocket",
  },
];

export const DELIVERABLES = [
  { title: "Award Memento", desc: "A gold-finished memento of distinction.", icon: "Trophy" },
  { title: "Exclusive Medal", desc: "Signature medal & ceremonial sash.", icon: "Medal" },
  { title: "Commemorative Photo Frame", desc: "Framed keepsake of your moment.", icon: "Image" },
  { title: "Dedicated Stage Time", desc: "Your spotlight & mic access on stage.", icon: "Mic" },
  { title: "Networking Opportunities", desc: "Connect with icons across industries.", icon: "Users" },
  { title: "LED Promotion for AV", desc: "Brand reel on the main LED (AV about awardee).", icon: "MonitorPlay" },
];

export const STAY_TOUR = [
  { title: "One-day Hut Stay", icon: "Home" },
  { title: "Food During Stay", icon: "UtensilsCrossed" },
  { title: "Tour — Nandi Hills / Isha", icon: "Mountain" },
  { title: "Shopping in Bangalore", icon: "ShoppingBag" },
  { title: "Post-Ceremony Dinner", icon: "Wine" },
  { title: "Connectivity Facilities", icon: "Wifi" },
];

export const PACKAGES = [
  {
    tier: "Regular Awardee",
    fee: "$250",
    badge: "Standard Registration",
    desc: "Full nomination, ceremony entry, all deliverables & dinner.",
  },
  {
    tier: "JFC Nominated",
    fee: "No Fee",
    badge: "Special Nomination",
    desc: "Registration fee waived for official JFC nominees.",
  },
  {
    tier: "JFC Stay & Tour",
    fee: "~$50 / person",
    badge: "Optional Add-on",
    desc: "Hut stay, food, tour, shopping, gala dinner & connectivity.",
  },
  {
    tier: "Accompanying Member",
    fee: "+$50 / extra",
    badge: "Guest Access",
    desc: "1 member allowed free. $50 per additional member (and per stay+tour).",
  },
];

export const FEES = {
  REGULAR: 250,
  COMMISSION: 50,
  EXTRA_MEMBER: 50,
  STAY_TOUR: 50,
};

export const inr = (n) => "$" + (n || 0).toLocaleString("en-US");
